import {Inject, Injectable, Optional} from '@angular/core';
import {RESPONSE} from '../../injection-tokens';
import {Response} from 'express';
import {PlatformService} from './platform.service';

@Injectable({
  providedIn: 'root'
})
export class ServerResponseService {
  constructor(private _platformService: PlatformService,
              @Optional() @Inject(RESPONSE) private _response?: Response) {
  }

  setStatusCode(statusCode: number) {
    if (this._platformService.isBrowser() || !this._response) {
      return;
    }

    this._response.statusCode = statusCode;
  }
}
